import { FieldValues, useForm, type UseFormProps } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { core, z } from 'zod';

z.config(z.locales.ru());

export type Zod = typeof z;

export function useSuperForm<
  TFieldValues extends FieldValues,
  TSchema extends core.$ZodLooseShape = Partial<Record<keyof FieldValues, core.SomeType>>,
>({
  schema,
  onSubmit,
  ...options
}: Omit<UseFormProps<TFieldValues>, 'resolver'> & {
  onSubmit?: (data: TFieldValues) => Promise<void> | void;
  schema: (zod: Zod) => TSchema;
}) {
  const form = useForm<TFieldValues>({
    ...options,
    resolver: zodResolver<TFieldValues, unknown, TFieldValues>(
      z.object(schema(z)) as z.ZodType<TFieldValues, TFieldValues>,
    ),
  });
  const onSubmitHandler = onSubmit ? form.handleSubmit(onSubmit) : undefined;
  return { ...form, onSubmit: onSubmitHandler };
}
